<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/f1HAR5/tc-custom/9781617752780.jpg?1705864385022" alt="This image is the cover for the book Not for Everyday Use"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Not for Everyday Use
      </h1>
      <p class="bookDescription body article font2">
        <b>The author explores her mother’s marriage—and fourteen pregnancies—in this “powerful memoir” (<i>Ebony</i>).</b><br/>  <br/><i>One of Oprah.com’s Best Memoirs of the Year</i><br/><i>Winner of the 2015 Hurston/Wright Legacy Award in Nonfiction</i><br/>  <br/> Tracing the four days between the moment she gets the dreaded call and the burial of her mother, Elizabeth Nunez tells of her lifelong struggle to cope with her parents’ ambitions for their children—and her mother’s seemingly unbreakable conviction that displays of affection are not for everyday use. Yet Nunez sympathizes with her parents, whose happiness is constrained by the oppressive strictures of colonialism; by the Catholic Church’s prohibition of artificial birth control which her mother obeys, terrified by the threat of eternal damnation (her mother gets pregnant fourteen times: nine live births and five miscarriages which almost kill her); and by the complexities of skin color in Caribbean society.<br/>  <br/> Through it all, a fierce love holds this family together, and helps carry Nunez through her grief, in this “intriguing [and] courageous memoir” (<i>Kirkus Reviews</i>).<br/>  <br/> “Nunez ponders the cultural, racial, familial, social, and personal experiences that led to what she ultimately understands was a deeply loving union between her parents. A beautifully written exploration of the complexities of marriage and family life.” —<i>Booklist</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elizabeth Nunez
      </h2>
      
      <p class="authorDescription body article"><B>Elizabeth Nunez</B> is the award-winning author of a memoir and nine novels, four of them selected as <I>New York Times</I> Editors' Choice. Her two most recent books are <I>Not for Everyday Use</I>, a memoir, which won the 2015 prestigious Hurston Wright Legacy Award for nonfiction, and the novel <I>Even in Paradise</I>, a contemporary version of Shakespeare's <I>King Lear</I>. Her other novels are: <I>Boundaries</I> (nominated for the 2012 NAACP Image Award for Outstanding Literary Fiction); <I>Anna In-Between</I> (PEN Oakland Award for Literary Excellence and long-listed for an IMPAC Dublin International Literary Award); <I>Prospero's Daughter</I> (2010 Trinidad and Tobago One Book, One Community selection, and the 2006 Florida Center for the Literary Arts One Book, One Community); <I>Bruised Hibiscus</I> (American Book Award); <I>Beyond the Limbo Silence</I> (Independent Publishers Book Award); <I>Grace</I>; <I>Discretion</I>; and <I>When Rocks Dance</I>. Nunez received her PhD from New York University and is a Distinguished Professor at Hunter College, CUNY, where she teaches courses on Caribbean Women Writers and Creative Writing.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Akashic Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9d6356a6